import { createSelector } from '@reduxjs/toolkit';
import getItems from './getItems';
import { getDayPartMenuConfig } from './config';
import {
  getLegacyDaypartsAvailability,
  getDaypartAvailability,
  isUsingLegacyDayparts,
} from '../utils/ordering/daypartMenuAvailability';
import getOrderDateTimeSelected from './getOrderDateTimeSelected';
import getDayparts from './getDayparts';

/**
 * # Get ItemAvailability By Id
 * This is used by these components:
 * - <StagedPurchases />
 */
export default (id?: string) =>
  createSelector(
    [getItems, getDayPartMenuConfig, getOrderDateTimeSelected, getDayparts],
    (
      items,
      { dayPartTimeBracket = 0 },
      dateTimeSelected,
      daypartSlots,
    ): boolean => {
      if (!items || !id || !items[id]) return true;

      const { availability, days, start, end, dayparts } = items[id];

      if (isUsingLegacyDayparts(dayparts)) {
        return getLegacyDaypartsAvailability({
          availability,
          days,
          start,
          end,
          timeBracket: dayPartTimeBracket,
          dateTimeSelected,
        });
      }

      return getDaypartAvailability({
        dayparts,
        daypartSlots,
        dateTimeSelected,
      });
    },
  );
